import { NotifyHelper } from "../../../helpers/toast";
import { eThuPhiTheoLopActionsObj } from "../../action-types/thu-phi/IThuPhiTheoLopActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const thuPhiTheoLopActions = {
  ...generateActions(eThuPhiTheoLopActionsObj, "THU_PHI_THEO_LOP"),
  ...generateActionForKey(
    eThuPhiTheoLopActionsObj,
    "THU_PHI_THEO_LOP",
    "CREATE_BIENLAITHU_SUCCESS",
    () => {
      NotifyHelper.Success("Đã tạo biên lai");
    }
  ),
  ...generateActionForKey(
    eThuPhiTheoLopActionsObj,
    "THU_PHI_THEO_LOP",
    "CREATE_BIENLAITHU_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
};
